<div class="container d-flex align-items-center justify-content-center">
  <div class="text-center my-5 card p-3 d-flex align-items-center">
    <h4 class="text-danger mb-2">{{ 'child.fail.title' | translate }}</h4>
    <hr />
    <p class="font-size-14" [innerHTML]="'child.fail.info' | translate | markdownTranslate"></p>
    <a class="btn btn-primary fw-bold" [routerLink]="['/']" [innerHTML]="'child.fail.button' | translate | markdownTranslate"></a>
  </div>
</div>
